import { IServiceBlockHeadingCell } from '@/models/commercial-proposals/blocks.store';
import { Stack, Switch, TextInput } from '@mantine/core';

export type IHeadingCellConfig = {
  title: string;
  subtitle: string;
  showSubtitle: boolean;
};

export default function HeadingCellSettings({
  config,
  onChange,
}: {
  config: IHeadingCellConfig;
  onChange: (config: IServiceBlockHeadingCell) => void;
}) {
  return (
    <Stack>
      <TextInput
        size="xs"
        label="Title"
        value={config.title}
        onChange={(e) => onChange({ ...config, title: e.target.value })}
      />

      <Switch
        size="xs"
        label="Show subtitle"
        checked={config.showSubtitle}
        onChange={(e) =>
          onChange({ ...config, showSubtitle: e.target.checked })
        }
      />

      {config.showSubtitle && (
        <TextInput
          size="xs"
          label="Subtitle"
          value={config.subtitle}
          onChange={(e) => onChange({ ...config, subtitle: e.target.value })}
        />
      )}
    </Stack>
  );
}
